import { cloneDeep, times, takeWhile } from 'lodash';
import createTaskType from '../../createTaskType';
import { PreA1, A1, A2 } from './Editor';

export default function NoteTaking(type = 'Pre-A1') {
    return createTaskType({
        id: 'labeling',
        label: 'Note Taking',
        skill: 'listening',
        v2: true,
        hasRubric: true,
        type: type,

        editor: type === 'Pre-A1' ? PreA1 : type === 'A1' ? A1 : A2,
        createItemsTemplate: () => times(6, index => ({
            is_example: index === 0,
            ...(index === 0 && { rubric_id: '' }),

            audio_id: '',
            stimulus_text_1: '',
            stimulus_text_2: '',

            // PreA1:
            // The true answer is the first few answer items, in order, marked as correct
            // The remaining answer items (marked incorrect) are distractors
            // A1:
            // One answer with a keys array
            answers: type === 'Pre-A1'
                ? times(10, index => ({
                    text: '',
                    display_order: index + 1,
                    is_correct_answer: index === 0,
                }))
                : [{
                    is_correct_answer: true,
                    key: [],
                }],
        })),

        backgroundImages: { count: 1 },

        convertToUploadFormat(task, { isNew }) {
            task = cloneDeep(task);
            return task;
        },

        getKeys: (item) => {
            if (type === 'Pre-A1') {
                const correct_answer = takeWhile(item.answers, x => x.is_correct_answer).map(x => x.text).join('');
                return [correct_answer];
            } else {
                const correct_answer = item.answers.find(x => x.is_correct_answer);
                return [correct_answer?.key?.join?.(', ') ?? 'N/A'];
            }
        }
    });
}